import React from "react";

const MyAddress = () => {
  return (
    <div className="lg:px-10 md:px-10 pt-10 md:pt-0 lg:pt-0">
      <h1 className="text-3xl font-bold">Billing Address</h1>
      <p>
        3522 Interstate 75 Business Spur, Sault Ste. Marie, MI 49783 New York
      </p>
    </div>
  );
};

export default MyAddress;
